'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _partial2 = require('lodash/partial');

var _partial3 = _interopRequireDefault(_partial2);

var _forEach2 = require('lodash/forEach');

var _forEach3 = _interopRequireDefault(_forEach2);

exports.default = storeListener;

var _handler = require('./handler');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
} // @TODO Move firebase to parent func.


function storeListener(types) {
  return function (firebase, store) {
    firebase.auth.onAuthStateChanged((0, _partial3.default)(_handler.handleAuth, firebase, store));
    var loadWatchType = (0, _handler.typeLoadWatch)(firebase, store);
    (0, _handler.dbChanges)(firebase, store);
    (0, _forEach3.default)(types, loadWatchType);
    return store;
  };
}